import { render, staticRenderFns } from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=template&id=1473d4b1"
import script from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports